import { APICore } from "./apiCore";

const api = new APICore();

function getWattiTemplatesApi() {
  return api.get("/web/watti-templates", null);
}

function getWattiTemplateConfigApi(templateName: string) {
  return api.get(`/web/watti-templates/config/${templateName}`, null);
}

function saveWattiTemplateConfigApi(data: {
  template_name: string;
  broadcast_name: string;
  body_mappings: any;
  status?: boolean;
}) {
  return api.create("/web/watti-templates/config", data);
}

function setWattiTemplateActiveApi(data: { template_name: string }) {
  return api.create("/web/watti-templates/set-active", data);
}

function sendWattiBroadcastApi(data: {
  template_name: string;
  recipients: string[];
}) {
  return api.create("/web/watti-broadcast", data);
}

function uploadWattiMediaApi(file: File) {
  return api.createWithFile("/web/watti-templates/upload-media", { image: file });
}

function getWattiMediaApi() {
  return api.get("/web/watti-media", null);
}

function addWattiMediaApi(title: string, file: File) {
  return api.createWithFile("/web/watti-media", { title, image: file });
}

function updateWattiMediaApi(id: number | string, title?: string, file?: File) {
  const data: any = {};
  if (title !== undefined) data.title = title;
  if (file !== undefined) data.image = file;
  return api.updateWithFile(`/web/watti-media/${id}`, data);
}

function deleteWattiMediaApi(id: number | string) {
  return api.delete(`/web/watti-media/${id}`);
}

export { 
  getWattiTemplatesApi, 
  getWattiTemplateConfigApi, 
  saveWattiTemplateConfigApi, 
  setWattiTemplateActiveApi,
  sendWattiBroadcastApi,
  uploadWattiMediaApi,
  getWattiMediaApi,
  addWattiMediaApi,
  updateWattiMediaApi,
  deleteWattiMediaApi,
};
